import React, { useState } from 'react';
import { Toaster, toast } from 'sonner';
import { Home } from './pages/Home';
import { LessonPage } from './pages/LessonPage';
import { DictionaryPage } from './pages/DictionaryPage';
import { ReviewPage } from './pages/ReviewPage';
import { VocabularyWord } from './components/VocabularyCard';
type View = 'home' | 'lesson' | 'dictionary' | 'review';
export function App() {
  const [currentView, setCurrentView] = useState<View>('home');
  const [reviewQueue, setReviewQueue] = useState<VocabularyWord[]>([]);
  const handleLessonComplete = (learnedWords: VocabularyWord[]) => {
    setReviewQueue(prev => [...prev, ...learnedWords]);
    setCurrentView('home');
    toast.success(`Great work! ${learnedWords.length} words ready to review.`);
  };
  const handleReviewComplete = () => {
    setReviewQueue([]);
    setCurrentView('home');
  };
  return <>
      <Toaster position="top-center" richColors data-id="element-0" />
      {currentView === 'home' && <Home onStartLesson={() => setCurrentView('lesson')} onOpenDictionary={() => setCurrentView('dictionary')} onStartReview={() => setCurrentView('review')} reviewCount={reviewQueue.length} data-id="element-1" />}
      {currentView === 'lesson' && <LessonPage onComplete={handleLessonComplete} data-id="element-2" />}
      {currentView === 'dictionary' && <DictionaryPage onExit={() => setCurrentView('home')} data-id="element-3" />}
      {currentView === 'review' && <ReviewPage words={reviewQueue} onExit={handleReviewComplete} data-id="element-4" />}
    </>;
}